import { Route } from "react-router-dom"
import TournamentSponsors from "../../components/tournament/tournament-sponsorships/tournament-sponsors";
import TournamentSponsorCreateEdit from "../../components/tournament/tournament-sponsorships/tournament-sponsor-create-edit";
import TournamentSponsorsCreateEditImage from "../../components/tournament/tournament-sponsorships/tournament-sponsors-create-edit-image";
import TournamentSponsorDetail from "../../components/tournament/tournament-sponsorships/tournament-sponsor-detail";
import TournamentSponsorFormResponses from "../../components/tournament/tournament-sponsorships/tournament-sponsor-form-responses";
import RecordFormsPage from "../../components/tournament/tournament-reporting/tournament-record-forms";
import TournamentSponsorRemove from "../../components/tournament/tournament-sponsorships/tournament-sponsor-remove";
import TournamentSponsorHoleAssignment from "../../components/tournament/tournament-sponsorships/tournament-sponsor-hole-assignment";
import TournamentSponsorExports from "../../components/tournament/tournament-sponsorships/tournament-sponsor-exports";
import TournamentSponsorshipTiers from "../../components/tournament/tournament-sponsorship-tiers/tournament-sponsorship-tiers";
import TournamentSponsorshipTierCreateEdit from "../../components/tournament/tournament-sponsorship-tiers/tournament-sponsorship-tier-create-edit";
import TournamentSponsorshipTierManageSponsors from "../../components/tournament/tournament-sponsorship-tiers/tournament-sponsorship-tier-manage-sponsors";
import TournamentSponsorshipTierRemove from "../../components/tournament/tournament-sponsorship-tiers/tournament-sponsorship-tier-remove";

export const getTournamentSponsorsRoutes = () => {
  return (
    <Route path="sponsors" element={<TournamentSponsors />}>
            <Route
              path=":sponsorID"
              element={<TournamentSponsorDetail />}
            ></Route>
            <Route
              path=":sponsorID/holes"
              element={<TournamentSponsorHoleAssignment />}
            ></Route>
            <Route
              path=":sponsorID/form-responses"
              element={<TournamentSponsorFormResponses />}
            ></Route>
            <Route
              path=":sponsorID/form-responses/forms"
              element={<RecordFormsPage />}
            ></Route>
            <Route
              path=":sponsorID/remove"
              element={<TournamentSponsorRemove />}
            ></Route>
            <Route
              path=":sponsorID/edit"
              element={<TournamentSponsorCreateEdit />}
            ></Route>
            <Route
              path=":sponsorID/edit/image"
              element={<TournamentSponsorsCreateEditImage />}
            ></Route>
            <Route path="add" element={<TournamentSponsorCreateEdit />}></Route>
            <Route
              path="documents"
              element={<TournamentSponsorExports />}
            ></Route>
            <Route
              path="add/image"
              element={<TournamentSponsorsCreateEditImage />}
            ></Route>
            <Route
              path="add/image-mobile"
              element={<TournamentSponsorsCreateEditImage isMobile={true} />}
            ></Route>
            <Route
              path="sponsorship-tiers"
              element={<TournamentSponsorshipTiers />}
            ></Route>
            <Route
              path="sponsorship-tiers/:sponsorshipTierId/edit/manage-sponsors"
              element={<TournamentSponsorshipTierManageSponsors />}
            ></Route>
            <Route
              path="sponsorship-tiers/:sponsorshipTierId/remove"
              element={<TournamentSponsorshipTierRemove />}
            ></Route>
            <Route
              path="sponsorship-tiers/:sponsorshipTierId/edit"
              element={<TournamentSponsorshipTierCreateEdit />}
            ></Route>
            <Route
              path="sponsorship-tiers/add"
              element={<TournamentSponsorshipTierCreateEdit />}
            ></Route>
          </Route>
  )
}